import _ from 'lodash';
import EstimationWorker from '../../../components/workers/EstimationWorker';

export default async (taskId, ganttId, resourcesList) => {
  const tasksResourcesToEstimate = [{
    task_id: +taskId,
    gantt_id: +ganttId,
    resources: resourcesList.map(item => ({ resource_id: item.resource_id, value: item.value, valuePerDay: null })),
  }];

  const estimationWorkerData = await EstimationWorker.calculate(tasksResourcesToEstimate, 'changeTasks', 'updateTasksResourceEstimations');

  return resourcesList.map(item => {
    const resourceEstimation = _.get(estimationWorkerData.diff.resourceEstimations, [taskId, item.resource_id]);

    if (resourceEstimation) {
      return { ...item, valuePerDay: resourceEstimation.valuePerDay };
    }

    return item;
  });
};
